<script>
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
import { Bar, mixins } from 'vue-chartjs'

export default {
  components: {
    ChartJSPluginDatalabels,
  },
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: Object,
    options: Object,
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
</script>
